module.exports = __webpack_public_path__ + "img/emoji_06.4740f4f3.png";